import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {Provider} from 'rebass'
import Header from '../components/header'
import Footer from '../components/footer'
import Theme from '../theme' 
import './index.css'

const Layout = ({ children, data }) => (
    <div style={{width:'100%'}}>
      <Helmet
        title="JAIN S N & CO."
        meta={[
          { name: 'description', content: 'Sample' },
          { name: 'keywords', content: 'sample, something' },
        ]}
        link={[{rel:"icon", type:"image/png", href:"/favicon.ico", sizes:"32x32"}]}
      />
      <Provider theme={Theme}>
        <Header />
        <div>
          {children()}
        </div>
        <Footer />
      </Provider>
    </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout




// WEBPACK FOOTER //
// ./src/layouts/index.js